import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);


export default new Vuex.Store({
    state: {
        fontColor: "",
        navData: '',
        UserMessage: ''
    },
    mutations: {
        setFontColor(state, data) {
            state.fontColor = data;
        },
        updateNavData(state, navData) {
            state.navData = navData; // 更新 uid
        },
        updateUserMessage(state, UserMessage) {
            state.UserMessage = UserMessage; // 更新 uid
        },
    },

});